import React  from 'react'
import { GetStates } from '../../../api/services/shared';
import DropDown from '../dropdown';

const StatesDropDown = (props) => {
    return <DropDown api={GetStates} search textField="Name" descriptionField="Code" valueField="Id" {...props} />
}

export default StatesDropDown
